import Vue from 'vue'
import Vuex from 'vuex'
import { GetBusinessHotelList,GetBusinessRoomscaleByhotel } from '@/api/api_business_hotel_and_scale'
import cookie from '../common/cookie.js'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    subMenuDataSource:[],
    showSubMenu: false,
    subMenuCookieId:null,
    landlord: null,
    rolesAll:null,
    menuShow: true,
    hotel: [],
    currentHotelID: '',
    header: '',
    param: '',
    status: 1,
    query: '',
    orderStatusList: {
      1: {
        orderStatus: 1,
        orderQuery: ''
      },
      2: {
        orderStatus: 2,
        orderQuery: ''
      },
      6: {
        orderStatus: 6,
        orderQuery: ''
      },
      7: {
        orderStatus: 7,
        orderQuery: ''
      }
    },
    orderStatus: 1,
    params: '',
    data: [],
    servalue: '',
    orderTop:null,
    lastInfo:'',
    pageYOffset: 0,
    hotelMemberNav:0,
    FinanceModuleNav:'1',
    deptNameArr: [] // 多级部门菜单
  },
  // 定义修改状态的函数
  mutations: {
    setLandlord(state, param) {
      state.landlord = param
    },
    setSubMenuCookieId(state, param) {
      state.subMenuCookieId = param
    },
    setSubMenuDataSource(state, param) {
      state.subMenuDataSource = param
    },
    setShowSubMenu(state, param) {
      state.showSubMenu = param
    },
    roles_vuex(state, param) {
      state.rolesAll = param
    },
    // user_vuex(state, param) {
    //   state.userInfo = param
    // },
    setHotel(state, param) {
      state.hotel = param.hotel
    },
    setMenu(state, param) {
      state.menuShow = param
    },
    setHeader(state, param) {
      state.header = param
    },
    setExit(state, param) {
      state.exit = param
    },
    setCurrentID(state, param) {
      state.currentHotelID = param
    },
    m_getaiyo(state, obj) {
      state.params = obj.params
    },
    // 搜索的值
    m_getServalue(state, obj) {
      state.servalue = obj.queryValue
    },
    // 搜索的值
    m_getOrder(state, obj) {
      state.orderTop = obj
    },
    lastInfo(state,param){
      state.lastInfo = param
    },
    setPageYOffset(state, val) {
      state.pageYOffset = val;
    },
    // 门店会员
    HOTELMEMBERBERNAV(state,val){
      state.hotelMemberNav = val;
    },
    // 财务管理
    FinanceModule(state,val){
      state.FinanceModuleNav = val;
    },
    SET_DEPT_MENU(state, deptNameArr) {
      state.deptNameArr = deptNameArr
    }
  },
  getters: {
    hotels(state) {
      if (state.hotel.length == 0) {
        store.dispatch('loadHotels')
      }else{
        return state.hotel
      }
    },
    currentID(state) {
      if (state.hotel.length == 0) {
        store.dispatch('loadHotels')
      } else if (!state.currentHotelID) {
        store.commit('setCurrentID', state.hotel[0].id)
      } else {
        return state.currentHotelID
      }
    }
  },
  actions: {
    async loadHotels({
      commit,
      dispatch,
      state
    }) {
      let params = {
        startPage: 1,
        recordNum: 300,
      }
      let result = await GetBusinessHotelList(params)
      if(result.ret == 1){
        if(result.data.length > 0){
          localStorage.setItem("c_hotel", JSON.stringify(result.data));
          commit('setHotel', {
          'hotel': result.data
          })
          let id = cookie.getCookie('currentID')
          if (id) {
            commit('setCurrentID', Number(id))
          } else {
            commit('setCurrentID', result.data[0].id)
            cookie.setCookie('currentID', result.data[0].id)
          }
        }else{
          return false
        }
      }else{
        this.Commom.backLogin(result);
      }
    },
    loadState({
      commit
    }, id) {
        GetBusinessRoomscaleByhotel({hotelId:id}).done(res=>{
            commit('setState', {statelist: res.data})
        })
    },
    loadStateList(state, arr) {
      for (let i = arr.length - 1; i >= 0; i--) {
        store.dispatch('loadState', arr[i].id)
      }
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js